import React, {useState, useEffect, useContext} from "react"
import {Button,  Box, Typography} from "@mui/material"
import {LoadingContext} from "@hoc/loading";
import {MessageContext} from "@hoc/messageNotification";
import Grid from '@mui/material/Grid';
import makeStyles from "@material-ui/core/styles/makeStyles";
import OutlinedInput from '@mui/material/OutlinedInput';
import {useHistory, useParams} from "react-router";
import {Item} from "./Item";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import {create, getById, update} from "@api/segment";
import { useConfirm } from 'material-ui-confirm';

const useStyles = makeStyles({
    main: {
        marginTop: '2em',
    },
    title: {
        fontSize: '24px',
        fontWeight: 'bold',
    },
    smallTitle: {
        fontSize: '14px',
        marginTop: '30px',
    },
    saveBlock: {
        marginTop: '20px',
    },
    label: {
        fontSize: '16px',
        fontWeight: 'bold',
    },
    input: {
        margin: '4px',
    },
});

export const EditSegment = () => {
    const classes = useStyles();
    const history = useHistory();
    let {id} = useParams();
    const [segment, setSegment] = useState([])
    const {setLoading} = useContext(LoadingContext);
    const {setErrorMessage} = useContext(MessageContext);
    const confirm = useConfirm();

    const createCategory = async () => {
        try {
            setLoading(true);
            setErrorMessage(null);

            await create(segment)
            history.push(`/segment`)
        } catch (e) {
            setErrorMessage(e);
        }
        setLoading(false);
    }

    const updateCategory = async (id) => {
        try {
            setLoading(true);
            setErrorMessage(null);

            await confirm({
                title: '',
                description: 'Attention! Editing segments does not change data in benefits! You have to make appropriate changes in benefits(segment field) manually!' })

            await update(segment)
            history.push(`/segment`)
        } catch (e) {
            setErrorMessage(e);
        }
        setLoading(false);
    }

    const save = () => {
        if (id) {
            updateCategory(id)
        } else {
            createCategory()
        }
    }

    const add = () => {
        if(!segment.segments) segment.segments = []
        segment.segments.push({indId: Math.floor(Math.random() * 100000000)})
        setSegment({...segment})
    }

    const remove = (ind) => {
        segment.segments.splice(ind, 1)
        setSegment({...segment})
    }

    const onChange = (event) => {
        const name = event.target.name
        let value = event.target.value

        setSegment({...segment, ...{[name]: value}})
    }

    const updateSubSegment = (segments) => {
        setSegment({...segment, ...{segments}})
    }

    useEffect(() => {
        if (id) {
            const loadCategoryById = async (id) => {
                try {
                    setLoading(true);
                    setErrorMessage(null);
                    const segment = await getById(id)
                    setSegment(segment)
                } catch (e) {
                    setErrorMessage(e);
                }
                setLoading(false);

            }

            loadCategoryById(id)
        } else {
            setSegment({})
        }
    }, [id, setErrorMessage, setLoading])

    return (
        <Grid className={classes.main} container spacing={1}>
            <Grid item xs={12}>
                <Box display={"flex"} justifyContent={"space-between"}>
                    <Typography className={classes.title} component="h2">My a new segment</Typography>
                </Box>
            </Grid>
            <Typography className={classes.smallTitle} component="h4">Title of segment group</Typography>
            <Grid item xs={12}>
                <OutlinedInput
                    onChange={(e) => onChange(e)}
                    style={{width: '255px'}}
                    value={segment.name}
                    name='name'
                />
            </Grid>
            {segment?.segments?.length ? <Item data={segment.segments} remove={remove} onChangeData={updateSubSegment}/> : ''}

            <Grid item xs={12}>
                <Button onClick={add} className={classes.label} variant="text"><AddCircleIcon/>Create another segment</Button>
            </Grid>
            <Grid item xs={12} className={classes.saveBlock}>
                <Button variant="contained" onClick={() => save()}>Save category</Button>
            </Grid>
        </Grid>
    )
}